"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventType;
(function (EventType) {
    EventType["POINTER_DOWN"] = "pointerDown";
    EventType["POINTER_DRAG"] = "pointerDrag";
    EventType["POINTER_UP"] = "pointerUp";
    EventType["POINTER_STOP"] = "pointerStop";
    EventType["POINTER_INSPECT"] = "pointerInspect";
    EventType["POINTER_TAP"] = "pointerTap";
    EventType["POINTER_DOUBLE_TAP"] = "pointerDoubleTap";
    EventType["VIRTUAL_POINTER_CREATE"] = "virtualPointerCreate";
    EventType["VIRTUAL_POINTER_MOVE"] = "virtualPointerMove";
    EventType["VIRTUAL_POINTER_PINCH"] = "virtualPointerPinch";
    EventType["VIRTUAL_POINTER_DESTROY"] = "virtualPointerDestroy";
})(EventType || (EventType = {}));
exports.default = EventType;
//# sourceMappingURL=EventType.js.map